import { Quantizer } from '../typing'
export { default as MMCQ } from './mmcq'

export var WebWorker: Quantizer | null = null
